<template>
  <UIDropdownActions
    :data
    :class="{
      'w-full': $attrs.full !== undefined,
    }"
  >
    <template #default="{ toggle }">
      <UIButton
        v-bind="$attrs"
        :leading="PlusIcon"
        type="button"
        @click="toggle()"
      />
    </template>
  </UIDropdownActions>
</template>

<script setup lang="ts">
import { computed, h } from 'vue'

import { DocumentSource } from '@types'

import { DOCUMENT_ACTION_LABEL } from '@/entities/documents/utils/const'

import { PlusIcon } from '@heroicons/vue/24/outline'
import UIDocumentIcon from './DocumentIcon.vue'
import UIButton from '../Button/Button.vue'
import UIDropdownActions from '../Dropdown/DropdownActions.vue'

type Emits = {
  (e: 'select', value: DocumentSource): void
}

const emit = defineEmits<Emits>()

defineOptions({ inheritAttrs: false })

const data = computed(() => Object.values(DocumentSource)
  .map(source => ({
    label: DOCUMENT_ACTION_LABEL[source],
    icon: h(UIDocumentIcon, { source }),
    action: (hide: () => void) => {
      hide()
      emit('select', source)
    },
  }))
)
</script>
